import { render, staticRenderFns } from "./StandardSideMenu.vue?vue&type=template&id=8119f648&"
import script from "./StandardSideMenu.vue?vue&type=script&lang=js&"
export * from "./StandardSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports